export const pcbList = [
  {
    value: '0.6',
    disabled: false,
    mdh: [
      {
        value: '0.3mm↑',
        disabled: false,
      },
      {
        value: '0.25mm',
        disabled: false,
      },
      {
        value: '0.20mm',
        disabled: false,
      },
      {
        value: '0.15mm',
        disabled: false,
      }
    ]
  },
  {
    value: '0.8',
    disabled: false,
    mdh: [
      {
        value: '0.3mm↑',
        disabled: false,
      },
      {
        value: '0.25mm',
        disabled: false,
      },
      {
        value: '0.20mm',
        disabled: false,
      },
      {
        value: '0.15mm',
        disabled: false,
      }
    ]
  },
  {
    value: '1.0',
    disabled: false,
    mdh: [
      {
        value: '0.3mm↑',
        disabled: false,
      },
      {
        value: '0.25mm',
        disabled: false,
      },
      {
        value: '0.20mm',
        disabled: false,
      },
      {
        value: '0.15mm',
        disabled: false,
      }
    ]
  },
  {
    value: '1.2',
    disabled: false,
    mdh: [
      {
        value: '0.3mm↑',
        disabled: false,
      },
      {
        value: '0.25mm',
        disabled: false,
      },
      {
        value: '0.20mm',
        disabled: false,
      },
      {
        value: '0.15mm',
        disabled: false,
      }
    ]
  },
  {
    value: '1.6',
    disabled: false,
    mdh: [
      {
        value: '0.3mm↑',
        disabled: false,
      },
      {
        value: '0.25mm',
        disabled: false,
      },
      {
        value: '0.20mm',
        disabled: false,
      },
      {
        value: '0.15mm',
        disabled: false,
      }
    ]
  },
  {
    value: '2.0',
    disabled: false,
    mdh: [
      {
        value: '0.3mm↑',
        disabled: false,
      },
      {
        value: '0.25mm',
        disabled: false,
      },
      {
        value: '0.20mm',
        disabled: false,
      },
      {
        value: '0.15mm',
        disabled: false,
      }
    ]
  },
  {
    value: '2.5',
    disabled: false,
    mdh: [
      {
        value: '0.3mm↑',
        disabled: false,
      },
      {
        value: '0.25mm',
        disabled: false,
      },
      {
        value: '0.20mm',
        disabled: false,
      },
      {
        value: '0.15mm',
        disabled: false,
      }
    ]
  },
  {
    value: '3.0',
    disabled: false,
    mdh: [
      {
        value: '0.3mm↑',
        disabled: false,
      },
      {
        value: '0.25mm',
        disabled: false,
      },
      {
        value: '0.20mm',
        disabled: false,
      },
      {
        value: '0.15mm',
        disabled: false,
      }
    ]
  },
  {
    value: '3.2',
    disabled: false,
    mdh: [
      {
        value: '0.3mm↑',
        disabled: false,
      },
      {
        value: '0.25mm',
        disabled: false,
      },
      {
        value: '0.20mm',
        disabled: false,
      },
      {
        value: '0.15mm',
        disabled: false,
      }
    ]
  },
]

export const layerCountList = [
  {
    key: '1',
    value: '1',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['2.5', '3.0', '3.2'].includes(p.value)) { // 控制pcb是否禁用，payer count 为1时， pcb禁用'2.5', '3.0', '3.2'
        p.disabled = true;
      }
      p.mdh = p.mdh.map(mdh => {
        const m = { ...mdh };
        if (m.value !== '0.3mm↑') { // 控制mdh： Layer Count 为1时，所有pcb对应的Min. Drilled Hole都是仅保留0.3不禁用，其他全禁
          m.disabled = true;
        }
        return m;
      });
      return p;
    })
  },
  {
    key: '2',
    value: '2',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['2.5', '3.0', '3.2'].includes(p.value)) { // 控制pcb是否禁用
        p.disabled = true;
      }

      if (['1.6', '2.0'].includes(p.value)) { // 控制pcb是否禁用
        p.mdh = pcb.mdh.map((mdh) => {
          const m = { ...mdh };
          if (m .value=== '0.15mm') { // 控制mdh： Layer Count 为2时，且PCB Thickness为'1.6', '2.0'时，Min. Drilled Hole 仅禁用0.15，其他全放开
            m.disabled = true;
          }
          return m;
        })
      }
      return p;
    })
  },
  {
    key: '4',
    value: '4',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['3.0', '3.2'].includes(p.value)) {
        p.disabled = true;
      }
      if (['2.5', '2.0'].includes(p.value)) {
        p.mdh = pcb.mdh.map((mdh) => {
          const m = { ...mdh };
          if (m .value=== '0.15mm') {
            m.disabled = true;
          }
          return m;
        })
      }
      return p;
    })
  },
  {
    key: '6',
    value: '6',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['0.6', '0.8', '3.0', '3.2'].includes(p.value)) {
        p.disabled = true;
      }

      if (['2.5', '2.0'].includes(p.value)) {
        p.mdh = pcb.mdh.map((mdh) => {
          const m = { ...mdh };
          if (m .value=== '0.15mm') {
            m.disabled = true;
          }
          return m;
        })
      }
      return p;
    })
  },
  {
    key: '8',
    value: '8',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['0.6', '0.8', '3.0', '3.2'].includes(p.value)) {
        p.disabled = true;
      }

      if (['2.5', '2.0'].includes(p.value)) { // 判断哪些pcb需要特殊处理他的mdh
        p.mdh = pcb.mdh.map((mdh) => {
          const m = { ...mdh };
          if (m .value=== '0.15mm') { // 代表需要处理哪个mdh为禁用状态
            m.disabled = true;
          }
          return m;
        })
      }
      return p;
    })
  },
  {
    key: '10',
    value: '10',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['0.6', '0.8', '1.0', '3.0', '3.2'].includes(p.value)) {
        p.disabled = true;
      }

      if (['2.5', '2.0'].includes(p.value)) {
        p.mdh = pcb.mdh.map((mdh) => {
          const m = { ...mdh };
          if (m .value=== '0.15mm') {
            m.disabled = true;
          }
          return m;
        })
      }
      return p;
    })
  },
  {
    key: '12',
    value: '12',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['0.6', '0.8', '1.0', '1.2', '3.0', '3.2'].includes(p.value)) {
        p.disabled = true;
      }

      if (['2.5', '2.0'].includes(p.value)) {
        p.mdh = pcb.mdh.map((mdh) => {
          const m = { ...mdh };
          if (m .value=== '0.15mm') {
            m.disabled = true;
          }
          return m;
        })
      }
      return p;
    })
  },
  {
    key: '14',
    value: '14',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['0.6', '0.8', '1.0', '1.2', '3.2'].includes(p.value)) {
        p.disabled = true;
      }

      if (['2.5', '2.0', '3.0'].includes(p.value)) {
        p.mdh = pcb.mdh.map((mdh) => {
          const m = { ...mdh };
          if (m .value=== '0.15mm') {
            m.disabled = true;
          }
          return m;
        })
      }
      return p;
    })
  },
  {
    key: '16',
    value: '16',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['0.6', '0.8', '1.0', '1.2', '1.6', '3.2'].includes(p.value)) {
        p.disabled = true;
      }
      if (['2.5', '2.0', '3.0'].includes(p.value)) {
        p.mdh = pcb.mdh.map((mdh) => {
          const m = { ...mdh };
          if (m .value=== '0.15mm') {
            m.disabled = true;
          }
          return m;
        })
      }
      return p;
    })
  },
  {
    key: '18',
    value: '18',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['0.6', '0.8', '1.0', '1.2', '1.6'].includes(p.value)) {
        p.disabled = true;
      }
      if (['2.5', '2.0', '3.0', '3.2'].includes(p.value)) {
        p.mdh = pcb.mdh.map((mdh) => {
          const m = { ...mdh };
          if (m .value=== '0.15mm') {
            m.disabled = true;
          }
          return m;
        })
      }
      return p;
    })
  },
  {
    key: '20',
    value: '20',
    pcb: pcbList.map((pcb) => {
      const p = { ...pcb };
      if (['0.6', '0.8', '1.0', '1.2', '1.6'].includes(p.value)) {
        p.disabled = true;
      }
      if (['2.5', '2.0', '3.0', '3.2'].includes(p.value)) {
        p.mdh = pcb.mdh.map((mdh) => {
          const m = { ...mdh };
          if (m .value=== '0.15mm') {
            m.disabled = true;
          }
          return m;
        })
      }
      return p;
    })
  },
  // {
  //   key: '22-32',
  //   value: '22-32'
  // },
]